<footer>
  <div id="footerForLargeDevice" class="container">
    <div class="row justify-content-center justify-content-md-between">
      <div class="col-4">
        <p class="footerLine">
          <strong>Cotra Autotransport AG</strong>
        </p>
        <p class="footerLine">Hübelacherstrasse 16</p>
        <p class="footerLine">5242&nbsp;<a class="links" href="https://www.google.ch/maps/place/Cotra+Autotransport+AG/@47.4478114,8.2061702,17z/data=!4m5!3m4!1s0x47901511ff6064a5:0xa13189ca727fbde5!8m2!3d47.4478187!4d8.2070124" target="_blank">Lupfig</a></p>
        <a class="footerLine links" href="mailto:info@cotra.ch">info@cotra.ch</a>
        <p class="footerLine">{{translation.Phone}} <a class="links" href="tel:+41587103000">+41 58 710 30 00</a></p>
      </div>
      <div class="col-4">
        <p class="footerLine">
          <strong>Wheelnews</strong>
        </p>
        <p class="footerLine">Bresteneggstrasse 1</p>
        <p class="footerLine">5033&nbsp;<a class="links" href="https://www.google.ch/maps/place/wheelnews/@47.3874922,8.0863661,736m/data=!3m2!1e3!4b1!4m6!3m5!1s0x47903af84f0cf3c7:0x3f189a93dc65fb3d!8m2!3d47.3874886!4d8.088941!16s%2Fg%2F11c1tsz84d?entry=ttu&g_ep=EgoyMDI2MDEyOC4wIKXMDSoASAFQAw%3D%3D" target="_blank">Buchs AG</a></p>
        <a class="footerLine links" href="mailto:info@wheelnews.ch">info@wheelnews.ch</a>
        <p class="footerLine">{{translation.Phone}} <a class="links" href="tel:+41587103120">+41 58 710 31 20</a></p>
      </div>
      <div class="col-4">
        <p class="footerLine links" (click)="termsAndConditions()">{{translation.AgbHeaderPart1}}</p>
        <p class="footerLine">{{translation.ACompanyOf}}</p>
        <a class="footerLine links" href="http://www.ldc-holding.ch/" target="_blank">Lagerhäuser der Centralschweiz AG</a>
        <p class="footerLine">Webseite: <a class="footerLine links" href="http://www.cotra.ch/" target="_blank">Cotra</a></p>
        <p class="footerLine">Webseite: <a class="footerLine links" href="http://www.wheelnews.ch/" target="_blank">Wheelnews</a></p>
      </div>
    </div>
  </div>
  <div id="footerForSmallDevice" class="container unselectable">
    <div class="row justify-content-center">
      <div>&nbsp;© 2020 COTRA AUTOTRANSPORT AG&nbsp;</div>
      <div>&nbsp;|&nbsp;</div>
      <a class="links upperCase" href="#">{{translation.Contact}}</a>
      <div>&nbsp;|&nbsp;</div>
      <a class="links upperCase" href="#">{{translation.Impressum}}</a>
    </div>
  </div>
</footer>
